"use client";

import { c as _c } from "react/compiler-runtime";
import FacebookPlatformIcon from "@/assets/icons/facebookPlatform.svg";
import KickPlatformIcon from "@/assets/icons/kickPlatform.svg";
import TwitchPlatformIcon from "@/assets/icons/twitchPlatform.svg";
import TvIcon from "@/assets/icons/tv.svg";
import YoutubePlatformIcon from "@/assets/icons/youtubePlatform.svg";
import classes from "./streaming-channels-panel.module.scss";
const PLATFORM_ICONS: Record<string, React.ComponentType<React.SVGProps<SVGSVGElement>>> = {
  kick: KickPlatformIcon,
  twitch: TwitchPlatformIcon,
  youtube: YoutubePlatformIcon,
  facebook: FacebookPlatformIcon
};
export function PlatformIcon(t0) {
  const $ = _c(3);
  const {
    platform
  } = t0;
  const Icon = PLATFORM_ICONS[(platform ?? "").trim().toLowerCase()];
  if (Icon) {
    let t1;
    if ($[0] !== Icon) {
      t1 = <Icon width={28} height={28} className={classes.platformIcon} />;
      $[0] = Icon;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    return t1;
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <TvIcon width={20} height={20} className={classes.platformIconFallback} />;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}
export function formatPlatformUrl(url: string): string {
  return url.replace(/^(?:https?:\/\/)?(?:www\.)?|\/$/gi, "");
}